import React, { useState } from 'react';
import '../styles/FloorLayoutEditor.css';

interface SpaceDefaultsModalProps {
  isOpen: boolean;
  entityType: 'parking' | 'bicycle' | 'locker';
  currentDefaults: { width: number; height: number };
  onClose: () => void;
  onSave: (defaults: { width: number; height: number }) => void;
}

const SpaceDefaultsModal: React.FC<SpaceDefaultsModalProps> = ({
  isOpen,
  entityType,
  currentDefaults,
  onClose,
  onSave
}) => {
  const [width, setWidth] = useState(currentDefaults.width);
  const [height, setHeight] = useState(currentDefaults.height);

  if (!isOpen) return null;

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    onSave({ width, height });
    onClose();
  };

  const getEntityLabel = () => {
    if (entityType === 'parking') return 'Parking Space';
    if (entityType === 'bicycle') return 'Bicycle Space';
    return 'Locker';
  };

  return (
    <div className="floor-layout-modal-overlay" onClick={onClose}>
      <div className="floor-layout-modal" onClick={(e) => e.stopPropagation()}>
        <div className="floor-layout-modal-header">
          <h3>Update {getEntityLabel()} Sizes</h3>
          <button className="floor-layout-close-btn" onClick={onClose}>✕</button>
        </div>

        <form onSubmit={handleSubmit}>
          <div className="floor-layout-modal-body">
            <p style={{ marginBottom: '16px', color: '#6B7280' }}>
              This will update the default size for all spaces on this floor.
              Existing spaces will use these dimensions.
            </p>

            <div className="model-details-field">
              <label>Width (pixels)</label>
              <input
                type="number"
                className="form-input"
                value={width}
                onChange={(e) => setWidth(parseInt(e.target.value))}
                min="10"
                max="500"
                required
              />
            </div>

            <div className="model-details-field">
              <label>Height (pixels)</label>
              <input
                type="number"
                className="form-input"
                value={height}
                onChange={(e) => setHeight(parseInt(e.target.value))}
                min="10"
                max="500"
                required
              />
            </div>

            <div style={{
              marginTop: '16px',
              padding: '12px',
              background: '#F3F4F6',
              borderRadius: '6px',
              fontSize: '14px'
            }}>
              <strong>Preview:</strong> {width} × {height} pixels
            </div>
          </div>

          <div className="floor-layout-modal-footer">
            <button
              type="button"
              className="btn btn-secondary btn-md"
              onClick={onClose}
            >
              Cancel
            </button>
            <button
              type="submit"
              className="btn btn-primary btn-md"
            >
              Update All Spaces
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default SpaceDefaultsModal;
